
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Wrapper } from './styled';
import Credentials from '../GeneralTab/components/Credentials';
import { unselectAllCredentials } from 'store/Credentials/actions';

const CredentialsTab = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(unselectAllCredentials());
  }, [dispatch]);

  return (
    <Wrapper>
      <Credentials />
    </Wrapper>
  );
};

export default CredentialsTab;
